import React, { useEffect, useState } from 'react';

import Characteristics from '../../../../shared/components/Property/Characteristics';
import ClassicSale from './versions/classicSale';
import DeadSale from './versions/deadSale';

import { FadeIn } from 'hosman-material';
import VALUATIONS from '../../../api/ressources/SellerApp/valuations';

const EstimationResult = ({ sale }) => {
  const [valuation, setValuation] = useState(sale.last_yanport_valuation)
  const saleIsDead = sale.state === 'dead'

  useEffect(() => {
    if (valuation || !sale.last_yanport_valuation_id) return;

    const getValuation = async (valuationId) => {
      const response = await VALUATIONS.getValuation(valuationId)
      setValuation(response.data)
    }

    getValuation(sale.last_yanport_valuation_id)
  }, [sale]);

  return (
    <div data-testid='EstimationResult' className='mb-28'>
      <FadeIn>
        <div className='flex flex-col gap-10'>
          <div className='flex flex-col justify-center items-center gap-3'>
            <p className='h2 text-center'>
              Estimation instantanée
              <br className='block md:hidden' />
              <span className='hidden md:inline'>&nbsp;</span>
              <span className='text-ih-blue'>{sale.property.street_number} {sale.property.street_name}, {sale.property.zip_code} {sale.property.city}</span>
            </p>

            <Characteristics property={sale.property} short />
          </div>

          {!saleIsDead && <ClassicSale sale={sale} valuation={valuation} setValuation={setValuation} />}

          {saleIsDead && <DeadSale sale={sale} valuation={valuation} setValuation={setValuation} />}
        </div>
      </FadeIn>
    </div>
  );
}

export default EstimationResult;
